import Model from './user_trash.model'

let storeContent = utils.generateStore({
   Model,
   user_trashes: [],
   selected_user_trashes: [],
})

export default {
   state() {
      return {
         ...storeContent.state
      };
   },
   getters: {
      ...storeContent.getters
   },
   mutations: {
      ...storeContent.mutations
   },
   actions: {
      handleActions(ctx, payload) {
         if (payload.action === 'user_trash:edit') {
            
         } else if (payload.action === 'user_trash:delete') {
            
         } else if (payload.action === 'user_trash:view') {
            // $session.set('selected_user_trashes',payload.rows[0])
         }
      },
      async fetchUserTrash(ctx) {
         try {
            let res = await api.fetchEndpointSecure({
               resource: 'registry',
               action: 'audit:user_bin',
               data: {},
               meta_data: {}
            })
            
            ctx.commit('user_trashes', res.result.records);
         } catch (err) {
            throw err
         }
      },
      async fetchData(ctx) {
         try {
            await ctx.dispatch('fetchUserTrash')
            Event.$emit('loader:show', false)
         } catch (err) {
            throw err
         }
      },
   }
};